import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import { useEffect, useState } from "react";

const Review = () => {
  const reviewList = [
    {
      src: "/images/review1.png",
      txt: `싱크대가 막혀 연락드렸는데<br/>
빠르게 방문해서 깔끔하게 해결해주셨어요`,
    },
    {
      src: "/images/review2.png",
      txt: `화장실 하수구가 막혔는데 
친절하게<br/>설명해주시고 바로 해결해주셨습니다.`,
    },
    {
      src: "/images/review3.png",
      txt: `갑자기 역류해서 당황했는데<br/>
빠르게 와주셔서 정말 다행이었어요.`,
    },
    {
      src: "/images/review4.png",
      txt: `배관 상태 확인부터 작업까지<br/>
꼼꼼하게 해주셔서 만족했습니다.`,
    },
    {
      src: "/images/review5.png",
      txt: `변기가 계속 막혔는데 원인까지<br/>
찾아서 확실하게 해결해주셨어요.`,
    },
    {
      src: "/images/review6.png",
      txt: `늦은 시간에도 친절하게 상담해주시고<br/>
작업도 깔끔하게 해주셨습니다.`,
    },
    {
      src: "/images/review7.png",
      txt: `하수구 냄새 때문에 연락했는데<br/>
원인을 찾아 해결해주셔서 좋았어요.`,
    },
    {
      src: "/images/review8.png",
      txt: `다른 업체에서 못 고친 문제였는데<br/>
깔끔하게 해결해주셔서 만족합니다.`,
    },
    {
      src: "/images/review9.png",
      txt: `상담도 친절하고 작업도<br/>빠르게 진행해주셔서
정말 편했습니다.`,
    },
    {
      src: "/images/review10.png",
      txt: `갑작스러운 하수구 문제였는데<br/>
신속하게 방문해주셔서 잘 해결했습니다.`,
    },
  ];

  const [count, setCount] = useState(5);

  useEffect(() => {
    if (window.innerWidth > 800) {
      setCount(5);
    } else {
      setCount(1);
    }

    window.addEventListener("resize", () => {
      if (window.innerWidth > 800) {
        setCount(5);
      } else {
        setCount(1);
      }
    });

    return () => {
      window.removeEventListener("resize", () => {
        if (window.innerWidth > 800) {
          setCount(5);
        } else {
          setCount(1);
        }
      });
    };
  }, []);

  useEffect(() => {});
  return (
    <div
      id="review"
      className="relative w-full h-full px-[calc((100%-var(--container))/2)] lg:px-0 py-14 lg:py-28 xl:pb-36 bg-gradient-to-l to-[#002843] from-[#124ebe]"
    >
      {/* 상단 타이틀 */}
      <div className="text-center text-white tracking-tighter mb-7 lg:mb-14" data-aos="fade-up">
        <h3 className=" font-medium text-xl md:text-2xl">하수코솔루션을 이용해주신 고객님들의</h3>
        <h2 className="gbold ">
          감동 100% <span className="text-point">BEST&nbsp;REAL&nbsp;REVIEW</span>
        </h2>
        <p className="mx-auto my-5 text-base md:text-lg">
          고객님과 함께 성장해나가는 하수코솔루션
          <br />
          고객님들의 고민과 걱정을 하수코솔루션이 깔끔하게 해결해드리겠습니다.
        </p>
      </div>

      <Swiper
        spaceBetween={30}
        // centeredSlides={true}
        loop={true}
        slidesPerView={count}
        autoplay={{
          delay: 3500,
          disableOnInteraction: false,
        }}
        modules={[Autoplay]}
        className=" relative w-full h-full mx-auto grid"
      >
        {reviewList.map((v, i) => (
          <SwiperSlide key={i} className=" relative w-full h-full min-w-72 px-5 lg:px-0">
            <div className=" relative w-full h-full py-5">
              <div className="relative w-full h-full min-h-72 p-3 rounded-sm bg-white border shadow-md">
                <div className=" relative w-full h-fit text-center pb-3">
                  <p className="text-black lg:text-base break-keep" dangerouslySetInnerHTML={{ __html: v.txt }}></p>
                </div>
                <div className="relative w-full h-5 max-w-44 mx-auto mb-3">
                  <img
                    src="/images/iconStar.png"
                    alt="고객 만족도 별점 5점"
                    className=" relative w-full h-fit object-contain max-h-5"
                  />
                </div>
                <img
                  className="relative w-full h-auto object-cover object-center rounded-sm"
                  src={v.src}
                  alt={`하수코솔루션 고객 후기 ${i + 1}`}
                />
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default Review;
